import { useEffect, useState } from 'react'
import { Tab, Tabs } from '@mui/material'
import ProposalDetail from './ProposalDetail.jsx'
import StatusBtn from '../../atoms/status/StatusBtn.jsx'
import CommonModal from '../../atoms/modal/CommonModal.jsx'

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	}
}

export const ProposalHistory = ({ proposalHistory, handleClose, isOpen }) => {
	const [data, setData] = useState({})
	const [value, setValue] = useState(0)
	const { proposals, coupleTitle, vendor } = proposalHistory
	useEffect(() => {
		setValue(0)
	}, [isOpen])
	useEffect(() => {
		if (!!proposals?.length) setData(proposals[value])
	}, [proposals, value])

	const handleChange = (event, newValue) => setValue(newValue)
	const tagUI = () => {
		let revisionCount = proposals?.filter(
			(item) => item.changeDescription === 'Revision'
		)?.length
		let firstBidCount = proposals?.filter(
			(item) => item.changeDescription === 'First Bid'
		)?.length
		return proposals?.map((item, i) => {
			const isFirstBid = item.changeDescription === 'First Bid'
			if (isFirstBid && firstBidCount !== proposals.length - i)
				return <></>
			const flag = item.changeDescription === 'Revision'
			const label = flag
				? 'Revision ' + revisionCount--
				: item.changeDescription
			return <Tab key={i} label={label} {...a11yProps(i)} />
		})
	}
	if (!isOpen) return null
	return (
		<CommonModal
			open={isOpen}
			handleClose={handleClose}
			page="planner-payments"
			heading="Bid Histrory"
			subHeading={
				<div>
					{coupleTitle && (
						<h3
							style={{ marginBottom: '10px', color: '#000' }}
						>{`Proposal for ${coupleTitle || ''}`}</h3>
					)}
					<span>
						{[
							vendor?.businessType,
							vendor?.businessTypes?.join(', '),
							vendor?.customBusinessType,
						]
							.filter(Boolean)
							.join(', ') || ''}
					</span>
					<Tabs
						value={value}
						onChange={handleChange}
						variant="scrollable"
						scrollButtons="auto"
						allowScrollButtonsMobile
					>
						{tagUI()}
					</Tabs>
				</div>
			}
			Chip={
				data?.status === 'Approved' ? (
					<StatusBtn label="Bid Approved" variant="approved" />
				) : data?.status === 'Revision' ? (
					<StatusBtn label="Revision Requested" variant="revision" />
				) : ['Rejected', 'Declined']?.includes(data?.status) ? (
					<StatusBtn label="Bid Rejected" variant="error" />
				) : (
					''
				)
			}
		>
			<ProposalDetail proposalData={data} isStatus={true} />
		</CommonModal>
	)
}
